interface CommentBoxProps {
  eyebrow: string;
  heading: string;
  body: string;
}

/**
 * 協会コメントボックス。「全日本執事協会からのコメント」を紙色グラデ地で囲う。
 */
export default function CommentBox({ eyebrow, heading, body }: CommentBoxProps) {
  return (
    <div className="bg-[linear-gradient(90deg,#f8f6f0,#ffffff)] border-l-4 border-[#a38e65] p-8 sm:p-10">
      <span className="block font-['Playfair_Display',serif] uppercase tracking-[0.22em] text-[11px] text-[#8f7a56] mb-3">{eyebrow}</span>
      <h2 className="jba-display font-medium text-[#1a2942] text-xl sm:text-2xl mb-5">{heading}</h2>
      <div className="space-y-5">
        {body
          .split(/\n{2,}/)
          .map((s) => s.trim())
          .filter(Boolean)
          .map((p, i) => (
            <p key={i} className="text-[#333] text-[15px] sm:text-base leading-[1.95] font-['Noto_Serif_JP',serif]">{p}</p>
          ))}
      </div>
    </div>
  );
}
